import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  consultantId: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/scan/migrate',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useMigrateScans = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useMigrateScansLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useMigrateScans;
